import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-44dd75a9"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "Header" }
const _hoisted_2 = { class: "Caption" }
const _hoisted_3 = { class: "Caption" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, " ", -1))
const _hoisted_5 = { class: "Caption" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Accordion = _resolveComponent("Accordion")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["BlockDisplayBlock", _ctx.rootClasses])
  }, [
    (_ctx.hasAccordion)
      ? (_openBlock(), _createBlock(_component_Accordion, {
          key: 0,
          isOpenOnLoad: false
        }, {
          title: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.item.title), 1),
              _createElementVNode("span", {
                class: _normalizeClass(["Text", { IsBold: _ctx.item.isBold }])
              }, _toDisplayString(_ctx.item.text), 3)
            ])
          ]),
          default: _withCtx(() => [
            _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.mixWB('CALCULATIONS')), 1),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.item.extraTexts, (text) => {
              return (_openBlock(), _createElementBlock("p", {
                class: "Text",
                key: text
              }, _toDisplayString(text), 1))
            }), 128)),
            (_ctx.item.footNotes)
              ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.item.footNotes, (note) => {
                  return (_openBlock(), _createElementBlock("p", {
                    class: "FootNote",
                    key: note
                  }, [
                    _createElementVNode("span", null, _toDisplayString(note.pretext), 1),
                    _hoisted_4,
                    _createVNode(_component_router_link, {
                      to: note.link.href
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(note.link.text), 1)
                      ]),
                      _: 2
                    }, 1032, ["to"])
                  ]))
                }), 128))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }))
      : (_ctx.item.text)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.item.title), 1),
            (typeof _ctx.item.text === 'string')
              ? (_openBlock(), _createElementBlock("span", {
                  key: 0,
                  class: _normalizeClass(["Text", { IsBold: _ctx.item.isBold }])
                }, _toDisplayString(_ctx.item.text), 3))
              : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.item.text, (set) => {
                  return (_openBlock(), _createElementBlock("p", {
                    class: "Footnote",
                    key: set.text + set.title
                  }, [
                    (set.title)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createElementVNode("strong", null, _toDisplayString(set.title), 1),
                          _hoisted_6
                        ], 64))
                      : _createCommentVNode("", true),
                    _createElementVNode("span", null, _toDisplayString(set.text), 1)
                  ]))
                }), 128))
          ], 64))
        : _createCommentVNode("", true)
  ], 2))
}